var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",class:{'is-inline': _vm.isInline}},[(_vm.isLoading)?_c('app-backend-icon',{staticClass:"content-loading",attrs:{"icon":"loading"}}):_vm._e(),(!_vm.isLoading)?_c('div',{staticClass:"content-inner"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }